import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DefaultDeviceVersion, TDeviceVersion } from '../../data/Device'
import { TSetupStep } from '../../data/WorkflowSteps'
import { RunState } from './RunStore'
import { setup10Template } from './sliceSetup10BellavistaTemplate'
import { setup15Template } from './sliceSetup15DraegerTemplate'
import { TSetupStateData } from './sliceSetupCommonTypes'

const setupByDeviceVersion: Record<TDeviceVersion, TSetupStateData> = {
    '1.0': setup10Template,
    '1.5': setup15Template
}

function cloneSetupState(source: TSetupStateData): TSetupStateData {
    return JSON.parse(JSON.stringify(source)) as TSetupStateData
}

function createSetupState(deviceVersion: TDeviceVersion = DefaultDeviceVersion): TSetupStateData {
    return cloneSetupState(setupByDeviceVersion[deviceVersion] ?? setupByDeviceVersion[DefaultDeviceVersion])
}

const initialState: TSetupStateData = createSetupState(DefaultDeviceVersion)

export interface ISetSetupCheck {
    section: TSetupStep
    itemId: string
    value: boolean
}

export const setupStepsSlice = createSlice({
    name: 'setupSteps',
    initialState: initialState,
    reducers: {
        resetForDeviceVersion: (_state, action: PayloadAction<TDeviceVersion>) => {
            return createSetupState(action.payload)
        },
        setcheck: (state, action: PayloadAction<ISetSetupCheck>) => {
            state[action.payload.section]!.items[action.payload.itemId]!.checked = action.payload.value
            const allChecked = Object.values(state[action.payload.section]!.items).find(x => !x.checked) === undefined
            state[action.payload.section]!.allChecked = allChecked
        }
    }
})

export const selectSetupState = (state: RunState) => state.setupStepsSlice
export const { resetForDeviceVersion, setcheck } = setupStepsSlice.actions
export default setupStepsSlice.reducer